import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import ContactUs from './pages/ContactUs';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import CogradFellowship from './pages/CogradFellowship';
import Incubation from './pages/Incubation';
import IncubationRegistration from './pages/IncubationRegistration';
import Careers from './pages/Careers';
import VideoTestimonials from './pages/VideoTestimonials';
import NcfTraining from './pages/NcfTraining';
import NextGenSchool from './pages/NextGenSchool';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import NitiAayogFeature from './pages/NitiAayogFeature';
import IndependenceDay from './components/IndependenceDay';

// Hackathon microsite is code-split so it doesn't add weight to the rest of the site
const Hackathon = lazy(() => import('./pages/Hackathon'));
const HackathonRegister = lazy(() => import('./pages/HackathonRegister'));

// Outreach landing page — a shareable link, so it is code-split too
const YoungFounders = lazy(() => import('./pages/YoungFounders'));


function App() {
  return (
    <Router>
      <div className="App">
        <IndependenceDay />
        <Suspense fallback={<div style={{ minHeight: '100vh', background: '#F7F9FC' }} />}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services/>} />
          <Route path="/contact-us" element={<ContactUs/>} />
          <Route path="/privacy-policy" element={<Privacy/>} />
          <Route path="/terms-conditions" element={<Terms/>} />
          <Route path="/fellowship" element={<CogradFellowship/>} />
          <Route path="/incubation" element={<Incubation/>} />
          <Route path="/incubation/register" element={<IncubationRegistration/>} />
          <Route path="/incubation/testimonials" element={<VideoTestimonials/>} />
          <Route path="/careers" element={<Careers/>} />
          <Route path="/ncf-training" element={<NcfTraining/>} />
          <Route path="/nextgen-school" element={<NextGenSchool/>} />
          <Route path="/blog/cograd-featured-by-niti-aayog" element={<NitiAayogFeature/>} />
          <Route path="/hackathon" element={<Hackathon/>} />
          <Route path="/hackathon/register" element={<HackathonRegister/>} />
          <Route path="/sharktank-youngfounder" element={<YoungFounders/>} />
          {/* the link was shared as /youngfounder before the rename */}
          <Route path="/youngfounder" element={<Navigate to="/sharktank-youngfounder" replace />} />
          <Route path="/admin" element={<AdminLogin/>} />
          <Route path="/admin/dashboard" element={<AdminDashboard/>} />
        </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
